// extracted by mini-css-extract-plugin
module.exports = {"root":"Control_root__jX3ko","label":"Control_label__lTf8E","error":"Control_error__hzyNo"};